import parser from 'html-react-parser'
import React from 'react'

const Button = ({ block }) => {
  if (!block.innerHTML) {
    return null
  }

  const isCenter = block.attrs.align === 'center'

  return (
    <div className={isCenter ? 'flex aligncenter' : ''}>
      {parser(block.innerHTML)}
    </div>
  )
}

export default Button
